import React from 'react';
import { about } from '../../content/site';
import { Check } from '../Common/Icons';

import imgMain from '../../images/gallery/pic1.jpg';
import imgInset from '../../images/gallery/pic2.jpg';

const About = () => (
  <section className="section" id="about">
    <div className="container">
      <div className="about__grid">
        <div className="about__media reveal">
          <div className="about__media-main">
            <img
              src={imgMain}
              alt="LIDA Engineering crew working from scaffolding on a structural steel span"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="about__media-inset">
            <img
              src={imgInset}
              alt="Interior fit-out in progress on a LIDA Engineering commercial project"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>

        <div className="about__body reveal" style={{ '--reveal-delay': '120ms' }}>
          <p className="eyebrow">{about.eyebrow}</p>
          <h2>{about.title}</h2>

          <div style={{ marginTop: 'var(--s-6)' }}>
            {about.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>

          <ul className="about__roles">
            {about.roles.map((role) => (
              <li key={role} className="about__role">
                <Check size={14} />
                {role}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default About;
